export default "__VITE_ASSET__wFVQWw_$__"